import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Loader from "../Component/userdashboard/pageloader";

export default function RouteLoader({ children }) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return loading ? <Loader /> : children;
}